const en = {
  // Server action messages
  errUnknownPage: "Unknown page",
  errInvalidContent: "Invalid page content",
  errInvalidSettings: "Invalid settings",
  errUnknownRevision: "Unknown revision",
  errUnknownMenu: "Unknown menu",
  errInvalidMenu: "Invalid menu",
  errUnknownFile: "Unknown file",
  errAltTooLong: "Alt text must be 300 characters or fewer.",
  errTooLong: "Too long",
  publishedLive: "“{title}” and your theme styles are now live.",
  themeChanged: "Theme changed. Publish to make it live.",
  pageSettingsSaved: "Page settings saved.",
  unpublishedMsg: "Unpublished",
  draftDiscarded: "Draft discarded",
  revisionRestored: "Restored into the draft. Review it in the builder, then publish.",
  markedReviewed: "Marked as reviewed",
  menuSaved: "Menu saved — it's live on your store.",
  altSaved: "Alt text saved",

  // Builder page / editor
  noPagesYet: "No pages yet",
  noPagesBuilderDesc: "Create a page first, then design it here.",
  goToPages: "Go to pages",
  exitBuilder: "Exit builder",
  pageToEdit: "Page to edit",
  homeSuffix: "Home",
  previewSize: "Preview size",
  previewDesktop: "Desktop preview",
  previewTablet: "Tablet preview",
  previewMobile: "Mobile preview",
  undoShortcut: "Undo (Ctrl+Z)",
  redoShortcut: "Redo (Ctrl+Shift+Z)",
  pageNotLive: "This page has changes that aren't live",
  themeNotLive: "Theme styles have changes that aren't live",
  notLiveYet: "Not live yet",
  previewNewTab: "Preview in new tab",
  notSaved: "Not saved: {error}",
  editorPanels: "Editor panels",
  pageStructure: "Page structure and theme",
  editorTools: "Editor tools",
  tabSections: "Sections",
  tabText: "Text",
  tabTheme: "Theme",
  tabStyles: "Styles",
  pageText: "Page text",
  pageTextHint: "Plain text. Start a line with ## for a heading and - for a list item. Leave a blank line between paragraphs.",
  policyTemplateNote: "Policy templates are a starting point, not legal advice. Have them reviewed for your business and the countries you sell to.",
  livePreview: "Live preview",
  draftPreviewOf: "Draft preview of",
  draftPreviewTitle: "Draft preview of {title}",
  reload: "Reload",
  sectionSettings: "Section settings",
  showSection: "Show section",
  hideSection: "Hide section",
  sectionHiddenNote: "This section is hidden and won't appear on your store.",
  duplicate: "Duplicate",
  deleteSection: "Delete section",
  noSectionSelected: "No section selected",
  noSectionSelectedHint: "Choose a section in the list to edit its text, images and layout.",
  showSections: "Show sections",
  deleteSectionConfirmTitle: "Delete this section?",
  deleteSectionConfirmBody: "The {name} section and its content will be removed from the draft. You can undo this with Ctrl+Z, or hide the section instead.",
  publishConfirmTitle: "Publish your changes?",
  publishConfirmIntro: "Your edits are saved automatically as a draft that only you can see in the preview. Publishing copies the draft to your live store:",
  publishPageChanged: "The “{title}” page (has unpublished changes)",
  publishPageUnchanged: "The “{title}” page (no new changes)",
  publishThemeChanged: "Theme and styles (have unpublished changes)",
  publishThemeUnchanged: "Theme and styles (no new changes)",
  publishOtherPagesNote: "Other pages with drafts are published separately from the Pages screen. A revision is saved each time you publish, so you can restore earlier versions.",
  storeNotOpen: "Your store itself isn't open to customers yet. When you're ready, launch it from",
  dismiss: "Dismiss",
  allSaved: "All changes saved as draft",
  unsavedChanges: "Unsaved changes",
  couldntSave: "Couldn't save",
  couldntSaveRetry: "Couldn't save — retry",
  errSaveNetwork: "Couldn't reach the server. Check your connection — we'll keep your changes here.",
  confirmLeaveUnsaved: "Your latest changes couldn't be saved. Leave this page anyway?",
  errSaveFirst: "Save your current changes first (see the error at the top).",
  errNetworkRetry: "Couldn't reach the server. Please try again.",
  errPublishUnsaved: "Your latest changes couldn't be saved, so nothing was published. Fix the error and try again.",
  errPublishNetwork: "Couldn't reach the server. Nothing was published — please try again.",
  sectionAdded: "{name} added at position {position} of {total}.",
  movedTo: "{name} moved to position {position} of {total}.",
  sectionShown: "{name} shown.",
  sectionHidden: "{name} hidden.",
  sectionDuplicated: "{name} duplicated.",
  sectionDeleted: "Section deleted. Press Ctrl+Z to undo.",
  linkHome: "Home",
  linkShopAll: "Shop all products",
  linkCollection: "Collection: {title}",
  linkPage: "Page: {title}",
  loadingPreview: "Loading preview",

  // Section list
  noSections: "This page has no sections yet. Add one below.",
  pageSections: "Page sections",
  dragToReorder: "Drag to reorder",
  hidden: "Hidden",
  moveUp: "Move {name} up",
  moveDown: "Move {name} down",
  showItem: "Show {name}",
  hideItem: "Hide {name}",
  duplicateItem: "Duplicate {name}",
  deleteItem: "Delete {name}",
  removeItem: "Remove {name}",
  reorderHint: "Drag sections, use the arrows, or press Alt + ↑/↓ on a section to reorder.",
  addSection: "Add section",
  sectionLimit: "Section limit reached ({max})",
  sectionTypes: "Section types",

  // Section settings form
  textareaHint: "Use ## for a heading and - for list items.",
  urlHint: "A page on your store like /products or /pages/about, or a full https:// address.",
  noCollectionsHint: "You have no collections yet — newest products are shown.",
  newestProducts: "Newest products",
  betweenHint: "Between {min} and {max}.",
  change: "Change",
  selectImage: "Select image",
  selectImageHint: "From your media library or upload a new one",
  itemN: "Item {n}",
  noItems: "No items yet.",
  maxReached: "Maximum of {max} reached",
  addItem: "Add item",
  addItem_benefits: "Add benefit",
  addItem_testimonials: "Add quote",
  addItem_faq: "Add question",

  // Section registry (src/themes/sections.ts)
  section_hero: "Hero banner",
  section_hero_desc: "Large headline with an image and call to action.",
  section_featured_products: "Featured products",
  section_featured_products_desc: "A grid of products from a collection or your newest items.",
  section_featured_collections: "Collection list",
  section_featured_collections_desc: "Links to your published collections.",
  section_image_text: "Image with text",
  section_image_text_desc: "Tell your story next to an image.",
  section_promo_banner: "Promotional banner",
  section_promo_banner_desc: "A bold strip to highlight an offer.",
  section_benefits: "Benefits",
  section_benefits_desc: "Highlight shipping, returns, quality or service promises.",
  section_testimonials: "Testimonials",
  section_testimonials_desc: "Quotes from real customers. Only add genuine feedback you have permission to share.",
  section_rich_text: "Text block",
  section_rich_text_desc: "Heading and paragraphs. Supports simple formatting: ## headings and - lists.",
  section_newsletter: "Newsletter signup",
  section_newsletter_desc: "Collect consenting subscribers for your email marketing.",
  section_faq: "FAQ",
  section_faq_desc: "Frequently asked questions.",
  section_contact_info: "Contact information",
  section_contact_info_desc: "Shows the contact details from your store settings.",
  section_contact_form: "Contact form",
  section_contact_form_desc: "Customers can send you a message by email.",
  field_heading: "Heading",
  field_subheading: "Subheading",
  field_buttonLabel: "Button label",
  field_buttonLink: "Button link",
  field_imageMediaId: "Image",
  field_hero_imageMediaId: "Background image",
  field_alignment: "Alignment",
  field_height: "Height",
  field_overlay: "Darken image for readability",
  field_collectionId: "Collection (optional)",
  field_featured_products_limit: "Products to show",
  field_featured_collections_limit: "Collections to show",
  field_columns: "Columns on desktop",
  field_text: "Text",
  field_contact_info_text: "Intro text",
  field_imagePosition: "Image position",
  field_style: "Style",
  field_benefits_items: "Benefits",
  field_testimonials_items: "Quotes",
  field_faq_items: "Questions",
  field_showEmail: "Show email",
  field_showPhone: "Show phone",
  field_showAddress: "Show address",
  itemField_title: "Title",
  itemField_text: "Text",
  itemField_quote: "Quote",
  itemField_author: "Customer name",
  itemField_question: "Question",
  itemField_answer: "Answer",
  opt_alignment_left: "Left",
  opt_alignment_center: "Center",
  opt_height_small: "Small",
  opt_height_medium: "Medium",
  opt_height_large: "Large",
  opt_imagePosition_left: "Left",
  opt_imagePosition_right: "Right",
  opt_style_primary: "Brand color",
  opt_style_dark: "Dark",
  opt_style_light: "Light",

  // Theme panel
  pickTheme: "Pick a starting design. You can fine-tune colors and fonts in Styles.",
  premium: "Premium",
  current: "Current",
  useTheme: "Use {name}",
  switchToTheme: "Switch to {name}?",
  switchTheme: "Switch theme",
  switchThemeBody: "Your style customizations (colors, fonts, layout options) will be replaced by {name}'s defaults. Your pages, products and menus are kept.",
  premiumThemeNote: "{name} is a premium theme and requires a paid plan.",
  resetHome: "Also reset the home page layout",
  resetHomeHint: "Replaces your home page sections with {name}'s recommended layout.",
  resetHomeSeeAfter: "You'll see it after switching.",
  nothingChangesUntilPublish: "Nothing changes on your live store until you publish.",
  theme_aurora_category: "General retail",
  theme_aurora_desc: "Clean, versatile layout that suits almost any catalog.",
  theme_atelier_category: "Fashion & apparel",
  theme_atelier_desc: "Editorial typography and portrait imagery for clothing and accessories.",
  theme_voltage_category: "Electronics",
  theme_voltage_desc: "High-contrast, spec-friendly layout for gadgets and tech.",
  theme_bloom_category: "Beauty & cosmetics",
  theme_bloom_desc: "Soft palette and rounded shapes for skincare and beauty brands.",
  theme_hearth_category: "Home & furniture",
  theme_hearth_desc: "Warm neutrals and generous imagery for interiors and homeware.",
  theme_harvest_category: "Food & specialty goods",
  theme_harvest_desc: "Friendly, appetising design for food, drink and gourmet shops.",
  theme_pixel_category: "Digital products",
  theme_pixel_desc: "Minimal, fast layout for downloads, templates and courses.",

  // Styles panel (src/themes/registry.ts THEME_SETTING_FIELDS)
  logoFaviconIn: "Logo and favicon are set in",
  errHexColor: "Use a 6-digit hex color like #1a2b3c",
  colorPicker: "{name} picker",
  styleUrlHint: "A full https:// address, or a path on your store like /products.",
  styleGroup_colors: "Colors",
  styleGroup_typography: "Typography",
  styleGroup_layout: "Layout",
  styleGroup_headerFooter: "Header & footer",
  styleGroup_products: "Products",
  style_colorPrimary: "Brand color",
  style_colorPrimaryText: "Text on brand color",
  style_colorBackground: "Page background",
  style_colorSurface: "Cards & panels",
  style_colorText: "Text",
  style_colorMuted: "Secondary text",
  style_colorAccent: "Sale & highlight",
  style_fontHeading: "Heading font",
  style_fontBody: "Body font",
  style_radius: "Corner radius",
  style_buttonStyle: "Buttons",
  style_containerWidth: "Content width",
  style_spacing: "Spacing",
  style_headerLayout: "Header layout",
  style_stickyHeader: "Sticky header",
  style_announcementText: "Announcement bar text",
  style_announcementLink: "Announcement link",
  style_footerText: "Footer text",
  style_socialInstagram: "Instagram URL",
  style_socialFacebook: "Facebook URL",
  style_socialX: "X URL",
  style_socialTiktok: "TikTok URL",
  style_productImageRatio: "Product image shape",
  style_productCardStyle: "Product card",
  style_showVendor: "Show brand/vendor on cards",
  style_productPageLayout: "Product page layout",
  style_collectionColumns: "Catalog columns (desktop)",
  font_system: "System sans",
  font_serif: "System serif",
  opt_radius_none: "Square",
  opt_radius_small: "Small",
  opt_radius_medium: "Medium",
  opt_radius_large: "Large",
  opt_buttonStyle_solid: "Solid",
  opt_buttonStyle_outline: "Outline",
  opt_buttonStyle_pill: "Pill",
  opt_containerWidth_narrow: "Narrow",
  opt_containerWidth_normal: "Normal",
  opt_containerWidth_wide: "Wide",
  opt_spacing_compact: "Compact",
  opt_spacing_comfortable: "Comfortable",
  opt_spacing_airy: "Airy",
  opt_headerLayout_left: "Logo left",
  opt_headerLayout_center: "Logo centered",
  opt_productImageRatio_square: "Square",
  opt_productImageRatio_portrait: "Portrait",
  opt_productImageRatio_landscape: "Landscape",
  opt_productCardStyle_plain: "Plain",
  opt_productCardStyle_bordered: "Bordered",
  opt_productCardStyle_shadow: "Shadow",
  opt_productPageLayout_side: "Gallery beside details",
  opt_productPageLayout_stacked: "Gallery above details",

  // Pages
  pagesDesc: "Your home page, store policies and any extra pages like About or FAQ. Edits are saved as drafts until you publish.",
  noPagesDesc: "Create your first page — for example About us or Shipping information.",
  colPage: "Page",
  colUrl: "URL",
  colInNav: "In nav",
  colOrder: "Order",
  homePage: "Home page",
  kind_home: "Home",
  kind_standard: "Standard",
  kind_policy: "Policy",
  kind_contact: "Contact",
  kind_faq: "FAQ",
  kind_about: "About",
  editInBuilder: "Edit in builder",
  storePolicies: "Store policies",
  storePoliciesDesc: "Refund, privacy, terms and shipping policies were created from templates.",
  reviewed: "Reviewed",
  policiesTemplatesNote: "Templates are a starting point, not legal advice. They need review — ideally by a legal professional — to match how your business actually handles refunds, data and shipping, and the laws of the places you sell to. Edit the text of each policy in the builder's “Text” tab.",
  markPoliciesConfirmTitle: "Mark policies as reviewed?",
  markPoliciesConfirmBody: "Confirm you have read and adapted each policy for your business. This only updates your launch checklist — it doesn't publish anything.",
  markPoliciesReviewed: "Mark policies as reviewed",
  liveUnpublishedChanges: "Live · unpublished changes",

  // Page settings
  pageSettings: "Page settings",
  pageSettingsDesc: "Title, address and how the page appears in search results.",
  kindPageAt: "{kind} page at",
  previewDraft: "Preview draft ↗",
  revisions: "Revisions",
  revisionsDesc: "A revision is saved every time this page is published. Restoring loads it into the draft — it goes live only when you publish.",
  noRevisions: "No revisions yet",
  noRevisionsDesc: "Publish the page to create the first revision.",
  latestPublished: "Latest published",
  revisionMeta: "“{title}” · {count} sections",
  revisionMeta_one: "“{title}” · {count} section",
  restoreConfirmTitle: "Restore this revision into the draft?",
  restoreConfirmBody: "Your current draft content will be replaced by this revision. The live page doesn't change until you publish.",
  restoreIntoDraft: "Restore into draft",
  restore: "Restore",
  publishing: "Publishing",
  lastPublished: "Last published",
  lastEdited: "Last edited",
  draftNotLive: "The draft has changes that aren't live yet.",
  discardConfirmTitle: "Discard draft changes?",
  discardConfirmBody: "The draft goes back to the live version. Unpublished edits are lost.",
  discardDraft: "Discard draft",
  unpublishPageConfirmTitle: "Unpublish this page?",
  unpublishPageConfirmBody: "Visitors will no longer see it. Links to it will show “not found”. You can publish it again any time.",
  deletePage: "Delete page",
  deletePageBody: "Deleting removes the page and its revisions. Menu links pointing to it will stop working.",
  deletePageConfirmTitle: "Delete “{title}”?",

  // Page forms
  homeAlwaysAt: "The home page always lives at",
  pageWillBeAt: "Your page will be at",
  slugRedirectHint: "Changing the URL of a live page keeps old links working with a redirect.",
  showInNav: "Show in navigation",
  showInNavHint: "Adds this page to the storefront header automatically.",
  seoListing: "Search engine listing",
  seoTitle: "SEO title",
  seoTitleHint: "Defaults to the page title.",
  seoDescription: "SEO description",
  seoDescriptionHint: "A short summary shown in search results.",
  hideFromSearch: "Hide from search engines",
  hideFromSearchHint: "Adds a noindex tag. Use for thank-you or private pages.",
  createPage: "Create page",
  createPageNote: "The page starts as a draft. You'll design it in the builder next, then publish when ready.",
  createAndEdit: "Create and edit",
  saveSettings: "Save settings",

  // Navigation
  navDesc: "Choose the links shown in your store's header and footer. Menu changes go live as soon as you save.",
  groupStore: "Store",
  linksToDraftsTitle: "Some links point to unpublished pages",
  linksToDraftsBody: "{links} — visitors will see “not found” until you publish those pages.",
  linksToDraftsBody_one: "{links} — visitors will see “not found” until you publish that page.",
  mainMenu: "Main menu",
  mainMenuDesc: "Shown in the header of every page.",
  footerMenu: "Footer menu",
  footerMenuDesc: "Shown at the bottom of every page — a good place for policies and contact.",
  errAddLabel: "Add a label",
  errChooseLink: "Choose a link",
  errLinkFormat: "Use a path like /products or a full https:// address",
  errNetworkKept: "Couldn't reach the server. Your changes are still here — try again.",
  linkFallback: "link",
  itemRemoved: "{name} removed.",
  saveMenu: "Save menu",
  noLinks: "No links yet. Add your first link below.",
  label: "Label",
  labelPh: "e.g. Shop",
  linkTo: "Link to",
  customUrl: "Custom URL…",
  urlPh: "/pages/about or https://…",
  maxLinks: "Maximum of {max} links",
  addLink: "Add link",

  // Media
  mediaDesc: "Images for products, pages and banners, plus private files delivered to customers who buy digital products.",
  tabImages: "Images",
  tabPrivate: "Private files",
  searchByFilename: "Search by file name",
  searchImagesByFilename: "Search images by file name",
  missingAlt: "{count} images on this page have no alt text. Alt text describes images for people using screen readers and helps search engines.",
  missingAlt_one: "{count} image on this page has no alt text. Alt text describes images for people using screen readers and helps search engines.",
  noFilesMatch: "No files match your search",
  noImagesYet: "No images yet",
  noPrivateYet: "No private files yet",
  noImagesDesc: "Upload product photos, banners and other images. They're optimised automatically.",
  noPrivateDesc: "Private files (PDF, ZIP, EPUB, MP3, MP4) are only available to customers through secure download links after purchase.",
  missingAltTitle: "Missing alt text",
  noAlt: "No alt",
  colFile: "File",
  colSize: "Size",
  colUploaded: "Uploaded",
  added: "Added",
  deleteFileConfirmTitle: "Delete {name}?",
  deleteFileConfirmBody: "Files attached to a product or already purchased by a customer can't be deleted.",
  deleteFile: "Delete file",
  imageDetails: "Image details",
  closeDetails: "Close details",
  copyUrl: "Copy URL",
  altText: "Alt text",
  altHint: "Describe what's in the image, e.g. “Blue ceramic mug on a wooden table”. Leave empty only for decorative images.",
  saveAlt: "Save alt text",
  deleteImageConfirmBody: "Images used by a product, collection, page or as your logo can't be deleted — remove them there first.",
  deleteImage: "Delete image",
  uploadImages: "Upload images",
  uploadPrivate: "Upload private files",
  uploadImagesHint: "Images are public so they can appear on your store. Select an image to add alt text.",
  uploadPrivateHint: "Private files never get a public URL. Attach them to a digital product so buyers receive secure, expiring download links.",
  selectImageDetailsHint: "Select an image to see its details, edit alt text or delete it.",
  filesUploaded: "{count} files uploaded.",
  filesUploaded_one: "{count} file uploaded.",

  // Media picker
  chooseImage: "Choose an image",
  uploadNewImage: "Upload a new image",
  errLoadImages: "Couldn't load images.",
  errNetwork: "Network error — check your connection and try again.",
  loadingImages: "Loading images",
  noImagesMatch: "No images match your search.",
  libraryEmpty: "Your media library is empty. Upload an image above.",
  imagePages: "Image pages",
};

export default en;
